import { Alert, AlertDescription, AlertTitle } from "@chakra-ui/react"

interface IPropsAlerts {
    message: string
    type?: 'error' | 'info' | 'success' | 'warning' | 'loading'
    title: string
}

const Alerts = ({ message, type, title }: IPropsAlerts) => {
    return (
        <>
            <Alert
                status={type ?? 'error'}
                variant='subtle'
                flexDirection='column'
                alignItems='center'
                justifyContent='center'
                textAlign='center'
                height='120'>
                    <AlertTitle mt={4} mb={1} fontSize='lg'>
                        {title}
                    </AlertTitle>
                    <AlertDescription maxWidth='sm'>
                        {message}
                    </AlertDescription>
            </Alert>
        </>
    )
};

export default Alerts;